import React from 'react';
import classNames from 'classnames';

import Icon, { ChatIcon, QuoteIcon } from '../utils/icons';

const QaDetails = ({
  id,
  questions = [],
  slangQuestions = [],
  answers = [],
  tags = [],
  isActive = false,
  setActive = () => {},
  onClick = () => {},
}) => {
  const classes = classNames({
    'qa-list-item': true,
    'qa-list-item-active': isActive,
  });

  return (
    <div className={classes} onClick={onClick}>
      <div className="qa-list-item-id">{id}</div>
      {questions &&
        questions.map((q, i) => (
          <div className="qa-list-item-question" key={`${q.text}-${i}`}>
            <div className="qa-list-item-question-icon">
              <Icon icon={QuoteIcon} />
            </div>{' '}
            {q.text}
          </div>
        ))}
      {slangQuestions &&
        slangQuestions.map((q, i) => (
          <div
            className="qa-list-item-question qa-list-item-question-slang"
            key={`${q.text}-${i}`}
          >
            <div className="qa-list-item-question-icon">
              <Icon icon={ChatIcon} />
            </div>{' '}
            {q.text}
          </div>
        ))}
      {answers &&
        answers.map((a, i) => (
          <div
            className="qa-list-item-answer qa-list-item-answer-full"
            key={`${a.text}-${i}`}
          >
            {a.text}
          </div>
        ))}
      {tags && tags.length > 0 && (
        <div className="qa-list-item-tags">
          {tags.map(tag => (
            <div key={tag.id} className="qa-list-item-tag">
              {tag.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default QaDetails;
